<template>
  <div>
    <div v-wechat-title="'《最强蜗牛》月光下的约定'"></div>
    <div class="pc-page">
      <div class="logo"></div>
      <div class="banner"></div>
      <div class="qrcode-box"></div>
    </div>
  </div>

</template>
<script>
import { getTimeStamp } from '@/utils/utils';
import { mapActions } from 'vuex';

export default {
  components: {},
  props: {
    logger: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      enterLink: '',
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 分享
      this.enterLink = 'https://h5.qingcigame.com/snail/midAutumn/anniversary';
      this.monitoringEquipment(this.enterLink);
      this.isSetShare(this.enterLink);
    });
  },
  computed: {},
  watch: {
    logger: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.logger.sum('中秋_PC端');
        }
      }
    }
  },
  methods: {
    monitoringEquipment(linkUrl) {
      if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
        location.href = `${linkUrl}${getTimeStamp()}`
      }
    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: "中秋节：双故事线救嫦娥",
        imgUrl: "https://download4.qcplay.com/qcgame-admin/3CZlD6IKJ0wa6jX3WFhsJPJU8KfS2C9mbp8drO0H.jpg",
        desc: "组建营救小队，领取丰厚谢礼",
      })
    },
    ...mapActions(["setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url('./index.less');
</style>



// WEBPACK FOOTER //
// src/pages/snail/midAutumn/pc/index.vue